module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "store-content"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "gray-box"
  }, [_c('div', {
    staticClass: "gallery-wrapper"
  }, [_c('div', {
    staticClass: "gallery"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('div', {
    staticClass: "big"
  }, [_c('img', {
    attrs: {
      "src": _vm.big,
      "alt": _vm.product.productName
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "sku-custom-title"
  }, [_c('h4', [_vm._v(_vm._s(_vm.product.productName))]), _vm._v(" "), _c('h6', [_c('span', [_vm._v(_vm._s(_vm.product.subTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "params-name"
  }, [_vm._v("数量")]), _vm._v(" "), _c('buy-num', {
    attrs: {
      "limit": Number(_vm.product.limitNum)
    },
    on: {
      "edit-num": _vm.editNum
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "buy"
  }, [_c('y-button', {
    staticStyle: {
      "width": "145px",
      "height": "50px",
      "line-height": "48px"
    },
    attrs: {
      "text": "加入购物车",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.addCart(_vm.product.productId, _vm.product.salePrice, _vm.product.productName, _vm.product.productImageBig)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item-info gray-box"
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm.productMsg) ? _c('div', {
    staticClass: "img-item"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.productMsg)
    }
  }, [_vm._v(_vm._s(_vm.productMsg))])]) : _c('div', {
    staticClass: "no-info"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/no-data.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          该商品暂无内容数据\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be3a1d00","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Mall/goodsDetail.vue
// module id = 678
// module chunks = 0